import "./About.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import TheDigitalAtelier from "./sections/TheDigitalAtelier";
import OurServiceArea from "./sections/OurServiceArea";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <NavigationHeader />
      <TheDigitalAtelier />
      <OurServiceArea />
      <Footer />
    </div>;
}